// Standard filters to use with angular apps.
// version 1.8
// Should be used in conjunction with
//     cpay-standard.0-5.css or later (for some filters)
//     AngularJS + ngSanitize
//     JQuery

/*eslint no-unused-vars: ["error", {
    "varsIgnorePattern": ".*NGFilter",
    "argsIgnorePattern": "val"
}]*/

////////// Helper functions //////////

// Helper function to splice a char or set of chars from a string.
function spliceStr(str, index, omit, add) {
    'use strict';
    return str.slice(0, index) + (add || "") + str.slice(index + omit);
}

// Helper function to help filters parse and highlight search strings.
function highlightStr(evalStr, theHighlightStr) {
    'use strict';
    var returnStr = evalStr;
    if (theHighlightStr !== null && theHighlightStr !== undefined) { returnStr = evalStr.replace(new RegExp(theHighlightStr.trim(), "ig"), "<span class='highlighted-text'>" + theHighlightStr.toUpperCase() + "</span>"); }
    return returnStr;
}
// Helper function to evaluate if a character is a number.
function isItANumber(char) {
    'use strict';
    if (char >= '0' && char <= '9') {
        return true;
    }
    return false;
}
// Helper function to accept a str and then place thousands separators their appropriate locations.
// WIll convert incoming number to a string.
function showThousandsSeparator(num) {
    'use strict';
    var parts = num.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

////////// Angular CPAY standard filters //////////
// Add to your module using the following syntax: module.filter('filter_name', function_name)
// Example: myModule.filter('bool', boolNGFilter);

// Standard AngularJS filter that will accept true or false and format the CPAY-Standard-styled boolean indicator.
// CPAY Standard css and js files needed.
// Will also accept color as its second argument, and if "red", will turn the indicator red.
function boolNGFilter() {
    'use strict';
    return function (input, color) {
        if (input === true || input === "true") {
            return "<div class='trueIndicator " + color + "'></div>";
        }
        return "<div class='falseIndicator'></div>";
    };
}

// Standard AngularJS filter that wil return input (text) as a button. Onclick funtion is passed as its first argument.
// Will also accept color as its color class and if disabled (true/false).
function buttonSmallNGFilter($sce) {
    'use strict';
    return function (input, fn, color, disabled) {
        var disabledText = "";
        if (disabled === "true" || disabled === true) { disabledText = "disabled"; }
        if (input) { return $sce.trustAsHtml("<button class='small " + color + "' onclick='" + fn + "' " + disabledText + ">" + input + "</button>"); }
    };
}

// Standard AngularJS filter that will accept a number, and display it in dollar format.
// Will accept parameter to indicate decimal place to show. If this is not passed, filter will return an amount to the penny.
// Negative numbers will show as ($###.##) unless indicated by argument "minus" (boolean) (-$#.##).
// Null, empty and zero values will show as -, unless told otherwise with zeroDisplay.
// Passing signFirst as true will place the dollar sign before a negative sign: $-##.## or $(#.##).
function dollarNGFilter() {
    'use strict';
    return function (input, dec, zeroDisplay, minus, signFirst) {
        var num, thousNum;
        if (dec === null || dec === "" || dec === undefined) { dec = 2; }
        if (input !== null && input !== "" && input !== 0 && input !== undefined) {
            num = parseFloat(input);
            thousNum = showThousandsSeparator(Math.abs(num).toFixed(dec));
            if (num < 0) {
                if (minus) {
                    if (signFirst) {
                        return "$-" + thousNum;
                    }
                    return "-$" + thousNum;
                }
                if (signFirst) {
                    return "$(" + thousNum + ")";
                }
                return "($" + thousNum + ")";
            }
            return "$" + thousNum;
        }
        return zeroDisplay;
    };
}

// Standard AngularJS filter that will accept a string and format an email link to that string.
// Will also accept a subject (string) argument. If no subject argument is given, subject will be empty.
// Will also accept a string argument to highlight (for search). Pass empty subject if empty.
// Filter will NOT validate input as an email address.
function emailNGFilter() {
    'use strict';
    return function (input, subject, searchStr) {
        var subjectText = "";
        if (subject) { subjectText = "?Subject=" + subject.replace(/'/g, "&#39;").replace(/"/g, "&quot;").replace(/\s/g, "%20").replace(/&/, "%26"); }
        if (input !== null && input !== 0 && input !== undefined && input !== '') { return "<a href='mailto:" + input + subjectText + "'>" + highlightStr(input, searchStr) + "</a>"; }
    };
}

// Standard AngularJS filter that will join first name and last name (both arguments).
function fullNameNGFilter() {
    'use strict';
    return function (firstName, lastName, searchStr) {
        var fullname = firstName + " " + lastName;
        return highlightStr(fullname, searchStr);
    };
}

// Standard AngularJS filter that will accept a string and converts it to an associated full state name, if found. If not found, returns non-coverted input.
// Ex: CA -> California
// Ex: ZZ -> ZZ
// Will also accept a string argument to highlight (for search).
function fullStateNGFilter() {
    'use strict';
    return function (input, searchStr) {
        var returnVal = input,
            highlightAll = false,
            states = [
                {initial: "AL", value: "Alabama"},
                {initial: "AK", value: "Alaska"},
                {initial: "AZ", value: "Arizona"},
                {initial: "AR", value: "Arkansas"},
                {initial: "CA", value: "California"},
                {initial: "CO", value: "Colorado"},
                {initial: "CT", value: "Connecticut"},
                {initial: "DC", value: "Washington DC"},
                {initial: "DE", value: "Delaware"},
                {initial: "FL", value: "Florida"},
                {initial: "GA", value: "Georgia"},
                {initial: "HI", value: "Hawaii"},
                {initial: "ID", value: "Idaho"},
                {initial: "IL", value: "Illinois"},
                {initial: "IN", value: "Indiana"},
                {initial: "IA", value: "Iowa"},
                {initial: "KS", value: "Kansas"},
                {initial: "KY", value: "Kentucky"},
                {initial: "LA", value: "Louisiana"},
                {initial: "ME", value: "Maine"},
                {initial: "MD", value: "Maryland"},
                {initial: "MA", value: "Massachusetts"},
                {initial: "MI", value: "Michigan"},
                {initial: "MN", value: "Minnesota"},
                {initial: "MS", value: "Mississippi"},
                {initial: "MO", value: "Missouri"},
                {initial: "MT", value: "Montana"},
                {initial: "NE", value: "Nebraska"},
                {initial: "NV", value: "Nevada"},
                {initial: "NH", value: "New Hampshire"},
                {initial: "NJ", value: "New Jersey"},
                {initial: "NM", value: "New Mexico"},
                {initial: "NY", value: "New York"},
                {initial: "NC", value: "North Carolina"},
                {initial: "ND", value: "North Dakota"},
                {initial: "OH", value: "Ohio"},
                {initial: "OK", value: "Oklahoma"},
                {initial: "OR", value: "Oregon"},
                {initial: "PA", value: "Pennsylvania"},
                {initial: "RI", value: "Rhode Island"},
                {initial: "SC", value: "South Carolina"},
                {initial: "SD", value: "South Dakota"},
                {initial: "TN", value: "Tennessee"},
                {initial: "TX", value: "Texas"},
                {initial: "UT", value: "Utah"},
                {initial: "VT", value: "Vermont"},
                {initial: "VA", value: "Virginia"},
                {initial: "WA", value: "Washington"},
                {initial: "WV", value: "West Virginia"},
                {initial: "WI", value: "Wisconsin"},
                {initial: "WY", value: "Wyoming"}];
        $.each(states, function (i, state) {
            if (input && input.toUpperCase().trim() === state.initial) {
                if (searchStr !== null && searchStr !== undefined && searchStr.toUpperCase().trim() === state.initial) {
                    highlightAll = true;
                }
                input = state.value;
                return false;
            }
        });
        if (highlightAll) {
            returnVal = "<span class='highlighted-text'>" + input.toUpperCase() + "</span>";
        } else {
            returnVal = highlightStr(input, searchStr);
        }
        return returnVal;
    };
}

// Standard AngularJS filter for finding growth between two numbers.
// Negative return values (string) will be formatted with a leading minus sign.
// Positive return values (string) will be formatted with a leading plus sign.
// If the comparedStat is 0, function will return "+TILT%".
function growthNGFilter() {
    'use strict';
    return function (originalStat, comparedStat, dec) {
        var returnVal;
        if (dec === null) { dec = 0; }
        if (comparedStat !== 0 && comparedStat !== null) {
            returnVal = (originalStat - comparedStat) / comparedStat;
            if (returnVal >= 0) {
                returnVal = "+" + Math.abs((returnVal * 100).toFixed(dec)) + "%";
            } else {
                returnVal = "-" + Math.abs((returnVal * 100).toFixed(dec)) + "%";
            }
        } else {
            returnVal = '';
        }
        return returnVal;
    };
}

// Standard AngularJS filter for applying a specified filter name if it exists.
function ifFilterExistsNGFilter() {
    'use strict';
    return function (input, argText) {
        if (input !== null && input !== "") {
            return "| " + input + argText;
        }
    };
}

// Standard AngularJS filter that will accept a url and out an img html object with that url as its href.
// Will also accept width and height as additional arguments. If you'd like to specify height but not width, pass width argument as null or empty.
function imgNGFilter() {
    'use strict';
    return function (input, width, height) {
        var widthText = "",
            heightText = "";
        if (input) {
            if (width !== undefined) { widthText  = " width='" + width + "'"; }
            if (height !== undefined) { heightText  = " height='" + height + "'"; }
            return "<img src='" + input + "'" + widthText + heightText + ">";
        }
    };
}

// Standard AngularJS filter that determines if the index is the current sortIndex, and if so, shows appropriate sortIndicator.
function isSortNGFilter() {
    'use strict';
    return function (input, index, sortIdx, direction, sortVal) {
        var returnVal = input,
            dirIndicator = "",
            openSortSpan = "<span class='bold'>",
            closeSortSpan = "</span>";
        if (input) {
            if (index === sortIdx) {
                if (direction === "descending" || direction === "down") {
                    dirIndicator = "<div class='sortIndicator descending'></div>";
                } else if (direction === "ascending" || direction === "up") {
                    dirIndicator = "<div class='sortIndicator ascending'></div>";
                } else {
                    dirIndicator = "";
                }
                if (input === "First/Last Name") {
                    if (sortVal !== null && sortVal === "Last Name") {
                        returnVal = "First/" + openSortSpan + "Last" + closeSortSpan + " Name" + dirIndicator;
                    } else {
                        returnVal = openSortSpan + "First" + closeSortSpan + "/Last Name" + dirIndicator;
                    }
                } else {
                    returnVal = openSortSpan + input + closeSortSpan + dirIndicator;
                }
            }
            return returnVal;
        }
    };
}

// Standard AngularJS filter that accepts a number and returns the appropriate month name, abbreviated.
function monthShortNameNGFilter() {
    'use strict';
    return function monthShortName(month) {
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        if (month >= 1 && month <= 12) {
            return months[month - 1];
        }
    };
}

// Standard AngularJS filter that accepts a number and returns the appropriate month name.
function monthLongNameNGFilter() {
    'use strict';
    return function monthLongName(month) {
        var months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (month >= 1 && month <= 12) {
            return months[month - 1];
        }
    };
}

// Standard AngularJS filter that accepts a number and returns the appropriate month name.
function monthNameNGFilter() {
    'use strict';
    return function monthName(month, abbr) {
        var months = {
            long: ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        };
        if (month >= 0 && month <= 11) {
            if (abbr) {
                return months.short[month];
            }
            return months.long[month]
        }
    };
}

// Standard AngularJS filter for creating pagination elements
// base: current page (counting up from 1)
// argument 1: how many records per page
// argument 2: total amount of records (on all pages)
// argument 3: how many records displayed on the current page
// argument 4: name of the function to call when user hits Previous button (will pass current page as the argument, must be global)
// argument 5: name of the function to call when user hits Next button (will pass current page as the argument, must be global)
// Will fail if these arguments are not passed
function paginationNGFilter($sce) {
    'use strict';
    return function (currPage, recsPerPage, totRecords, reportLength, goToPageFunction) {
        currPage = parseInt(currPage, 10);
        var firstRec = ((currPage - 1) * recsPerPage) + 1,
            lastRec = ((currPage - 1) * recsPerPage) + reportLength,
            prevText = "<button class='paginationButton prevPage disabled'></button>",
            nextText = "<button class='paginationButton nextPage disabled'></button>",
            firstText = "<button class='paginationButton firstPage disabled'></button>",
            lastText = "<button class='paginationButton lastPage disabled'></button>",
            pageText = "",
            currPageClass = "",
            onClickText = "",
            lastPage = Math.ceil(totRecords / recsPerPage),
            paginationNums = [],
            itemsToRemove = [],
            largeItemsToRemove = [],
            additionOffset = 0;
        if (currPage !== 1) {
            prevText = "<button class='paginationButton prevPage' onclick='" + goToPageFunction + "(" + (currPage - 1) + ")'></button>";
            firstText = "<button class='paginationButton firstPage' onclick='" + goToPageFunction + "(1)'></button>";
        }
        if (currPage < lastPage) {
            nextText = "<button class='paginationButton nextPage' onclick='" + goToPageFunction + "(" + (currPage + 1) + ")'></button>";
            lastText = "<button class='paginationButton lastPage' onclick='" + goToPageFunction + "(" + lastPage + ")'></button>";
        }
        paginationNums.push(currPage - 2, currPage - 1, currPage, currPage + 1, currPage + 2);
        $.each(paginationNums, function (i, val) {
            if (val < 1) { itemsToRemove.push(i); }
        });
        $.each(itemsToRemove.reverse(), function (i, val) {
            paginationNums.splice(val, 1);
            paginationNums.push(paginationNums[paginationNums.length - 1] + 1);
        });
        $.each(paginationNums, function (i, val) {
            if (val > lastPage) { largeItemsToRemove.push(i); }
        });
        $.each(largeItemsToRemove.reverse(), function (i, val) {
            paginationNums.splice(val + additionOffset, 1);
            if (paginationNums[0] - 1 >= 1) {
                paginationNums.unshift(paginationNums[0] - 1);
                additionOffset++;
            }
        });
        $.each(paginationNums, function (i, val) {
            currPageClass = "";
            onClickText = "";
            if (currPage === val) {
                currPageClass = "currentPage";
            } else {
                onClickText = "onclick='" + goToPageFunction + "(" + val + ")'";
            }
            pageText += "<button class='paginationButton " + currPageClass + "' " + onClickText + ">" + val + "</button>";
        });
        if (currPage) {
            return $sce.trustAsHtml("Showing " + firstRec + " - " + lastRec + " of " + totRecords + "<br>" + firstText + prevText + pageText + nextText + lastText);
        }
    };
}

// Standard AngularJS filter that will accept a number, and display it in percent format.
// Will accept parameter to indicate decimal place to show. If this is not passed, filter will return amount to a full percent.
// Negative numbers will show as (###.##%).
// Null, empty and zero values will show as nothing, unless told otherwise with zeroDisplay.
// Passing true for percentOutside will place the % outside of negative parenthesis.
// This filter will not convert regular numbers to percent. "12.34" will return as "12.34%," not "1234%." To convert pass input * 100.
function percentNGFilter() {
    'use strict';
    return function (input, dec, zeroDisplay, minus, percentOustide) {
        var num, thousNum;
        if (dec === null || dec === "") { dec = 0; }
        if (input !== null && input !== "" && input !== 0) {
            num = parseFloat(input);
            thousNum = showThousandsSeparator(Math.abs(num).toFixed(dec));
            if (num < 0) {
                if (minus) {
                    return "-" + thousNum + "%";
                }
                if (percentOustide) {
                    return "(" + thousNum + ")%";
                }
                return "(" + thousNum + "%)";
            }
            return thousNum + "%";
        }
        return zeroDisplay;
    };
}

// Standard AngularJS filter that will accept a number or string and format as a standard phone number.
// Will also accept a search string (would have to be numbers) to highlight (ignoring formatting).
// US country codes are stripped. (Even if they are part of a search string.)
// Example: SearchStr: 1234; input: 12345678901: output: <Highlighted>(234</Highlighted>) 567-8901.
function phoneNGFilter() {
    'use strict';
    return function (input, searchStr) {
        if (input) {
            var nonDigitInput = input.toString().replace(/\D/g, ''),
                highlighted = nonDigitInput.split(""),
                openCityPosition = 0,
                closeCityPosition = 0,
                dashPosition = 0,
                numOfNums = 0,
                removeUSCountryCode = false,
                countryCodePos,
                returnVal;
            if (searchStr !== null && searchStr !== undefined) {
                highlighted = nonDigitInput.replace(new RegExp(searchStr, "ig"), "<span class='highlighted-text'>" + searchStr + "</span>").split("");
            }
            switch (nonDigitInput.length) {
            case 7: // ####### -> ###-####
                $.each(highlighted, function (i, val) {
                    if (isItANumber(highlighted[i])) {
                        numOfNums++;
                        if (numOfNums === 3) { dashPosition = i + 1; }
                    }
                });
                highlighted.splice(dashPosition, 0, "-");
                returnVal = highlighted.join("");
                break;
            case 10: // +1PPP####### -> C (PPP) ###-####
                $.each(highlighted, function (i, val) {
                    if (isItANumber(highlighted[i])) {
                        numOfNums++;
                        if (numOfNums === 3) { closeCityPosition = i + 1; }
                        if (numOfNums === 6) { dashPosition = i + 1; }
                    }
                });
                highlighted.splice(dashPosition, 0, "-");
                highlighted.splice(closeCityPosition, 0, ") ");
                highlighted.splice(0, 0, "(");
                returnVal = highlighted.join("");
                break;
            case 11: // +CPPP####### -> C (PPP) ###-####
                $.each(highlighted, function (i, val) {
                    if (isItANumber(highlighted[i])) {
                        numOfNums++;
                        if (numOfNums === 1) {
                            openCityPosition = i + 1;
                            if (highlighted[i] === "1") {
                                removeUSCountryCode = true;
                                countryCodePos = i;
                            }
                        }
                        if (numOfNums === 4) { closeCityPosition = i + 1; }
                        if (numOfNums === 7) { dashPosition = i + 1; }
                    }
                });
                highlighted.splice(dashPosition, 0, "-");
                highlighted.splice(closeCityPosition, 0, ") ");
                highlighted.splice(openCityPosition, 0, " (");
                if (removeUSCountryCode) { highlighted.splice(countryCodePos, 1); }
                returnVal = highlighted.join("");
                break;
            case 12: // +CCCPP####### -> CCC (PP) ###-####
                $.each(highlighted, function (i, val) {
                    if (isItANumber(highlighted[i])) {
                        numOfNums++;
                        if (numOfNums === 3) { openCityPosition = i + 1; }
                        if (numOfNums === 5) { closeCityPosition = i + 1; }
                        if (numOfNums === 8) { dashPosition = i + 1; }
                    }
                });
                highlighted.splice(dashPosition, 0, "-");
                highlighted.splice(closeCityPosition, 0, ") ");
                highlighted.splice(openCityPosition, 0, " (");
                returnVal = highlighted.join("");
                break;
            default:
                returnVal = highlighted.join("");
            }
            return returnVal;
        }
    };
}

// Standard Angular JS filter that will return a "Today," "Tomorrow," "Yesterday" dates.
// pass zoneOffset as true if there is a zone offset.
// pass withTime as true if there you'd like to include the Time in the output.
// If not today, tomorrow or yesterday, filter will return input as entered.
// To show those dates as formatted, pipe through Angular standard date filter first, like this:
// {{myDate | date: 'mediumDate' | relativeDate: myDate}}
function relativeDateNGFilter() {
    'use strict';
    return function (formattedDate, dateStr, zoneOffset, withTime, zoneStr) {
        var returnVal = formattedDate,
            match = null,
            dates = {
                s: new Date(), // yesterday
                t: new Date(), // Today
                u: new Date() // tomorrow
            },
            d = new Date(dateStr), // date in UTC to display
            z = zoneOffset === true ? d.getTimezoneOffset() / 60 : 0, // time zone offset to apply to d
            h,
            time = "",
            m = d.getMinutes(),
            mer = "AM",
            zoneStr = zoneStr !== undefined && zoneStr !== '' ? ' ' + zoneStr : '';
        dates.s.setDate(dates.t.getDate() - 1);
        dates.u.setDate(dates.t.getDate() + 1);
        d.setHours(d.getHours() + z);
        h = d.getHours();
        if (h > 12) { h = h - 12; mer = "PM"; }
        if (h === 0) { h = 12; }
        if (m < 10) { m = "0" + m; }
        if (dateStr) {
            $.each(dates, function (key, date) {
                if (date.getFullYear() === d.getFullYear() &&
                        date.getMonth() === d.getMonth() &&
                        date.getDate() === d.getDate()) {
                    // Match!
                    switch (key) {
                    case "s":
                        match = "Yesterday";
                        break;
                    case "t":
                        match = "Today";
                        break;
                    case "u":
                        match = "Tomorrow";
                        break;
                    }
                    return false;
                }
            });
            if (withTime) { time = " (" + h + ":" + m + " " + mer + zoneStr +")"; }
            if (match !== null) { returnVal = match + time; }
        }
        return returnVal;
    };
}

// Standard AngularJS filter that will return a remove button.
// First argument must be the onclick function (online string) to call.
// cpay-standard.css needed.
function removeNGFilter($sce) {
    'use strict';
    return function (input, fn) {
        if (input === true || input === "true") {
            return $sce.trustAsHtml("<button class='removeBtn small' onclick='" + fn + "'></button>");
        }
    };
}

// Standard AngularJS filter that will return a number of seconds as days:hours:mins:secs
function secondsToDateTimeNGFilter() {
    'use strict';
    return function (input, zeroMinDisplay, nanDisplay, padFirst) {
        var returnSegments = { sec: "", min: "", hour: "", day: ""},
            displayHour = false,
            displayMin = zeroMinDisplay ? true: false,
            padding = "";
        if ($.isNumeric(input)) {
            if (input >= 86400) { // days
                returnSegments.day = Math.floor(input / 86400);
                if (returnSegments.day < 10) {
                    padding = padFirst ? "0" : "";
                    returnSegments.day = padding + returnSegments.day + ":";
                } else {
                    returnSegments.day = returnSegments.day + ":";
                }
                input %= 86400;
                displayHour = true;
                displayMin = true;
            }
            if (input >= 3600 || displayHour) { // hours
                returnSegments.hour = Math.floor(input / 3600);
                if (returnSegments.hour < 10) {
                    padding = (padFirst || displayHour) ? "0" : "";
                    returnSegments.hour = padding + returnSegments.hour + ":";
                } else {
                    returnSegments.hour = returnSegments.hour + ":";
                }
                input %= 3600;
                displayMin = true;
            }
            returnSegments.min = Math.floor(input / 60); // minutes
            if (returnSegments.min === 0) {
                returnSegments.min = displayMin ? "00:" : ":";
            } else if (returnSegments.min < 10) {
                padding = (padFirst || displayMin) ? "0" : "";
                returnSegments.min = padding + returnSegments.min + ":";
            } else {
                returnSegments.min = returnSegments.min + ":";
            }
            input %= 60;
            returnSegments.sec = input; // seconds
            if (returnSegments.sec < 10) {
                returnSegments.sec = "0" + returnSegments.sec;
            }
            return returnSegments.day + returnSegments.hour + returnSegments.min + returnSegments.sec;
        }
        return nanDisplay;
    };
}

// Standard AngularJS filter that will return a status indicator
// cpay-standard.css needed.
// Valid colors: red, yellow, green, blue, grey, orange, purple, black and white.
function statusLargeNGFilter() {
    'use strict';
    return function (input, color) {
        return "<div class='largeStatusIndicator " + color + "'></div>" + input;
    };
}

// Standard AngularJS filter that will return a status indicator
// cpay-standard.css needed.
// Valid colors: red, yellow, green, blue, grey, orange, purple, black and white.
function statusSmallNGFilter() {
    'use strict';
    return function (input, color) {
        return "<div class='smallStatusIndicator " + color + "'></div>" + input;
    };
}

// Standard AngularJS filter that will return its input.
// Will also accept a search string to highlight if directed.
function textNGFilter() {
    'use strict';
    return function (input, searchStr) {
        return highlightStr(input, searchStr);
    };
}

// Removes any superflous zeroes hanging off a float.
// Accepts numbers (with dollar or
// expects input to be a string or a float.
function truncateZeroesNGFilter() {
    'use strict';
    return function (input, dec) {
        var splitInput,
            firstChar,
            charPos, // This character is a piece of shit, just like Joffrey Baratheon.
            finished = false;
        if (!input) {
            return input;
        }
        splitInput = input.toString().split(".");
        firstChar = splitInput.length > 0 && splitInput[1].search(/\D/) !== -1 ? splitInput[1].search(/\D/) : splitInput[1].length;
        charPos = parseInt(firstChar, 10);
        dec = dec !== undefined ? dec : 0;
        while (dec > firstChar) {
            splitInput[1] = spliceStr(splitInput[1], firstChar, 0, "0");
            firstChar++;
        }
        while (charPos > dec && !finished) {
            charPos--;
            if (splitInput[1].charAt(charPos) === "0") {
                splitInput[1] = spliceStr(splitInput[1], charPos, 1);
                firstChar--;
            } else { finished = true; }
        }
        return splitInput[0] + (firstChar === 0 ? "" : ".") + splitInput[1];
    };
}

// Standard AngularJS filter that will accept a string and format a link to the first argument (href).
// Will also accept target as its second argument.
function urlNGFilter() {
    'use strict';
    return function (input, href, target, searchStr) {
        var targetText = "";
        if (input) {
            if (target !== null && href !== "") {
                targetText = " target='" + target + "'";
            }
            if (href !== null && href !== "") {
                return "<a href='" + href + "'" + targetText + ">" + highlightStr(input, searchStr) + "</a>";
            }
            return highlightStr(input, searchStr);
        }
    };
}

// Standard AngularJS filter that will accept an int or string and format as a US phone number
// Ex: 12345678901234 -> "(234) 567-8901 ext.234"
function usPhoneNGFilter() {
    'use strict';
    return function (value) {
        if (value) {
            value = value.toString().trim().replace(/\D/g, "");
            if (value.charAt(0) === "1") { value = value.slice(1); }
            switch (value.length) {
            case 0:
                break;
            case 1:
            case 2:
            case 3:
                value = "(" + value + ")";
                break;
            case 4:
            case 5:
            case 6:
                value = "(" + value.slice(0, 3) + ") " + value.slice(3);
                break;
            case 7:
            case 8:
            case 9:
            case 10:
                value = "(" + value.slice(0, 3) + ") " + value.slice(3, 6) + "-" + value.slice(6);
                break;
            default:
                value = "(" + value.slice(0, 3) + ") " + value.slice(3, 6) + "-" + value.slice(6, 10) + " ext." + value.slice(10);
            }
            return value;
        }
    };
}

// Will look for zip code plus four and display dash as appropriate
// Accepts string or number
function zipPlusFourNGFilter() {
    'use strict';
    return function (input) {
        var returnStr = input.toString().trim().replace(/\D/g, "");
        if (returnStr.length === 9) {
            return spliceStr(returnStr, 5, 0, "-");
        }
        return input;
    };
}
